export enum IconSize {
    Small = "small",
    Default = "default",
    Big = "big"
}
